<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
}
</script>
